const GamesModule = () => import(/* webpackChunkName: "games-module" */ './views/Module.vue');
const Casino = () => import(/* webpackChunkName: "casino" */ './views/Casino.vue');
// const FilteredCasinoGames = () =>  import(/* webpackChunkName: "indian-card-games" */ './views/FilteredCasinoGames.vue');

const GamesRoutes = {
    path: '/',
    component: GamesModule,
    children: [
        {
            path: 'casino/:section',
            name: 'Casino',
            component: Casino
        },
    ],
}

export default GamesRoutes;